import VDialog from 'vuetify/lib/components/VDialog/VDialog'

/*
  Extends v-dialog to override its show() method in order to
  prevent self focussing upon showing.
*/

export default {
  extends: VDialog,
  name: 'VDialogExt',

  methods: {
    show () {
      !this.fullscreen && !this.hideOverlay && this.genOverlay()
      // This is the line which causes all the trouble
      // this.$refs.content.focus()
      this.$listeners.keydown && this.bind()
    }
  }
}
